import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Tournaments everywhere and for everyone"),
  /*#__PURE__*/_createElementVNode("h3", { class: "font-weight-thin" }, "create, vote and shared.")
], -1)
const _hoisted_2 = { class: "px-4 py-2 bg-black text-center w-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Torneio io", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tournament_brackets = _resolveComponent("tournament-brackets")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_tournament_brackets)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "tonal",
                height: "72",
                "min-width": "164",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name: 'tournament-create'})))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" create ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(new Date().getFullYear()) + " — ", 1),
            _hoisted_3
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}